import AisinoButton from "./AisinoButton"
import React from "react";
import {ExportOutlined, EyeOutlined, RedoOutlined, SearchOutlined} from "@ant-design/icons/es/icons";
import CloseOutlined from "@ant-design/icons/es/icons/CloseOutlined";
import RightOutlined from "@ant-design/icons/es/icons/RightOutlined";
import DownloadOutlined from "@ant-design/icons/es/icons/DownloadOutlined";
import PrinterOutlined from "@ant-design/icons/es/icons/PrinterOutlined";
import LeftOutlined from "@ant-design/icons/es/icons/LeftOutlined";
import {getLanguage} from "../../source/js/common";

const commonLan = require('../../constant/js/formItemNameLabel/'+getLanguage()+'/common.js');


export const AisinoButtonView=(props)=>{
    return <AisinoButton {...props} icon={<EyeOutlined />}>{commonLan.viewButton.label}</AisinoButton>;
};


export const AisinoButtonExport=(props)=>{
    return <AisinoButton {...props} icon={<ExportOutlined />}>{commonLan.exportButton.label}</AisinoButton>;
};


export const AisinoButtonReset=(props)=>{
    return <AisinoButton {...props} icon={<RedoOutlined />}>{commonLan.resetButton.label}</AisinoButton>;
};


export const AisinoButtonSearch=(props)=>{
    return <AisinoButton {...props}  icon={<SearchOutlined />}>{commonLan.searchButton.label}</AisinoButton>;
};

export const AisinoButtonSubmit=(props)=>{
    return <AisinoButton {...props}  >{commonLan.submitButton.label}</AisinoButton>
};
export const AisinoButtonSave=(props)=>{
    return <AisinoButton {...props} >{commonLan.saveButton.label}</AisinoButton>
};


export class AisinoButtonType extends React.Component{

    type(props){
        const type=["view","export","reset",
            "search","submit","save","close",
            "cancel","next","download","print","previous"];
        switch (props.ui) {
            case type[0]:
                return {
                    icon:<EyeOutlined />,
                    children:commonLan.viewButton.label,
                    ...props
                };
            case type[1]:
                return {
                    icon:<ExportOutlined />,
                    children:commonLan.exportButton.label,
                    ...props
                };
            case type[2]:
                return {
                    icon:<RedoOutlined />,
                    children:commonLan.resetButton.label,
                    ...props
                };
            case type[3]:
                return {
                    type:"primary",
                    htmlType:"submit",
                    icon:<SearchOutlined />,
                    children:commonLan.searchButton.label,
                    ...props
                };
            case type[4]:
                return {
                    type:"primary",
                    htmlType:"submit",
                    children:commonLan.submitButton.label,
                    ...props
                };
            case type[5]:
                return {
                    type:"primary",
                    children:commonLan.saveButton.label,
                    htmlType:"submit",
                    ...props
                };
            case type[6]:
                return {
                    children:commonLan.closeButton.label,
                    icon:<CloseOutlined />,
                    ...props
                };
            case type[7]:
                return {
                    children:commonLan.cancelButton.label,
                    ...props
                };
            case type[8]:
                return {
                  icon:<RightOutlined />,
                  type:"primary",
                    children:commonLan.nextButton.label,
                    ...props
                };
            case type[9]:
                return {
                  icon:<DownloadOutlined />,
                    children:commonLan.downloadButton.label,
                    ...props
                };
            case type[10]:
                return {
                    icon:<PrinterOutlined />,
                    children:commonLan.printButton.label,
                    ...props
                };
            case type[11]:
                return {
                    icon:<LeftOutlined />,
                    type:"primary",
                  children:commonLan.previousButton.label,
                    ...props
                };
            default:
                return {
                    children:"默认按钮",
                    ...props
                }
        }

    }

    render(){
        return <AisinoButton {...this.type(this.props)} />
    }
}
